<template>
    <span>
        <form-query-button  @select-type="clickEvent('query')" v-if="QueryButtonShow"></form-query-button>
        <reset-button  @select-type="clickEvent('reset')" v-if="ResetButtonShow"></reset-button>
        <add-button  @select-type="clickEvent('add')" v-if="AddButtonShow"></add-button>
        <form-setting-button  @select-type="clickEvent('setting')" v-if="SettingButtonShow" :btnCon="btnCon"></form-setting-button>
        <export-button  @select-type="clickEvent('export')" v-if="ExportButtonShow"></export-button>
    </span>
   
</template>
  
  <script>
   import FormQueryButton from './FormQueryButton.vue'
   import FormSettingButton from './FormSettingButton.vue'
   import ExportButton from './ExportButton.vue'
   import ResetButton from './ResetButton.vue'
   import AddButton from './AddButton.vue'

export default {
    components: { FormQueryButton,ResetButton,ExportButton,AddButton,FormSettingButton },
    name: 'my-button',
    props: {
        btnCon: {
            type: String,
            default: () => {
                return "设置"
            }
        },
        QueryButtonShow: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        ExportButtonShow: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        ResetButtonShow: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        AddButtonShow: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        SettingButtonShow: {
            type: Boolean,
            default: () => {
                return false
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(type){
            this.$emit('select-type',type);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// index.vue?35e0cb06